import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import { SnackMessageType } from '../models/common';

export const useAppSnackbar = () => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  const enqueueSuccessSnackbar = (message?: SnackMessageType) =>
    enqueueSnackbar(message ?? t('common.saveSuccess'), {
      variant: 'success',
    });

  const enqueueErrorSnackbar = (message?: SnackMessageType) =>
    enqueueSnackbar(message ?? t('common.saveError'), {
      variant: 'error',
    });

  const enqueueWarningSnackbar = (message: SnackMessageType) =>
    enqueueSnackbar(message, {
      variant: 'warning',
    });

  const enqueueInfoSnackbar = (message: SnackMessageType) =>
    enqueueSnackbar(message, {
      variant: 'info',
    });

  return { enqueueSuccessSnackbar, enqueueErrorSnackbar, enqueueWarningSnackbar, enqueueInfoSnackbar, enqueueSnackbar };
};
